<template>
  <slot :primary-value="primaryValue" :fallback="fallback" />
</template>

<script setup lang="ts" generic="T">
// simple component allowing the use of a calculated value without performing double calculations
defineProps<{ primaryValue?: T; fallback?: T }>()
</script>

<style lang="scss" scoped></style>
